/*eslint-disable */
const $ = window.jQuery = require('jquery');  
import toast from '../../services/toast';
export default {
  name: 'make-super-admin',
  components: {},
  props: [],
  data () {
    return {
      submitted:false,
      first_name:'',
      last_name:'',
      email:'',
      organization:'',
      division:''
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    validateBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
            let data = {
              organization:this.$route.params.orgId,
              email:this.email,
            }
            if(this.first_name != null && this.first_name != ''){
              data.first_name = this.first_name;
            }
            if(this.last_name != null && this.last_name != ''){
              data.last_name = this.last_name;
            }
            if(this.division != null && this.division != ''){
              data.division = this.division;
            }
            this.$store.dispatch('makeSuperAdminFun', data)
              .then((res) => {  
                toast.success(res.data.msg);  
                // location.reload()          
                this.$router.push('/su/organization/')
              }).catch((err) => {
                toast.error(err.data.user_msg || err.data.msg);
              })
            return;
        }
      });
    }
  }
}


